import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Note } from '../../../types/Note';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const updateNote = async (uuid: string, formData: Note) => {
  const response = await CustomAxios.put(`notes/${uuid}`, formData);
  const { data } = response;
  return data;
};
interface UseUpdateNoteFormProps {
  uuid: string;
  onSuccessCallback: (data: Note) => void;
}
export function useUpdateNote({ uuid, onSuccessCallback }: UseUpdateNoteFormProps) {
  return useMutation({
    mutationFn: (formData: Note) => updateNote(uuid, formData),
    onSuccess: (data: Note) => {
      onSuccessCallback(data);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const note: Note = err.response.data as Note;
        queryClient.setQueryData([queryKeys.allNotes, note.uuid], note);
      }
    },
  });
}
